import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegionsLoading = (isLoading) => {
  return {
    type: actionTypes.SET_REGIONS_LOADING,
    payload: isLoading
  }
}
